import React from 'react';


class ProjectThumbnail extends React.Component {

  state = {
    showTitle: false
  }

  handleMouseEnterSquare = () => {
    if (!this.state.showTitle)  {
      this.setState({
        showTitle: true
      });
    }
  }

  handleMouseLeaveSquare = () => {
    if (this.state.showTitle)  {
      this.setState({
        showTitle: false
      });
    }
  }

  render () {
    return (
      <div className="col-xl-4 col-md-4" onClick={() => this.props.handleItemClick(this.props.id)}>
        <div className="card card-margins">
          <div className="square"
            onMouseEnter={this.handleMouseEnterSquare} 
            onMouseLeave={this.handleMouseLeaveSquare}>
            <div className="card-content">
              <img src={this.props.image === null ? "/static/media/logo.40f3dd1e.jpg" : this.props.image} alt={this.props.title}/>
              <div className="title_background">
                <p className={this.state.showTitle ? "project_title on" : "project_title"}>{this.props.title}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    );
  }

}


export default ProjectThumbnail;